import i18n from "~/plugins/i18n";
export default {
    fields: [
        {
            key: "_selected",
            label: "",
            sorter: false,
            filter: false,
            resizable: false,
            fixed: true,
            _style: "width:5%",
            _filter: false,
            _type: "Boolean"
        },
        {
            key: "id",
            label: "#",
            sorter: true,
            filter: true,
            fixed: true,
            _filter: true,
            _style: "width:10%",
            _type: "Integer"
        },
        {
            key: "name",
            label: "Name",
            sorter: true,
            filter: true,
            _filter: true,
            _style: "width:15%",
            _type: "Text"
        },
        {
            key: "active",
            label: "Active",
            sorter: true,
            filter: false,
            _filter: {
                active: false,
                value: null,
                condition: "is_equal_to",
                type: "select",
                options: [
                    { value: "1", label: i18n.t("active") },
                    { value: "0", label: i18n.t("disable") },
                ],
            },
            _style: "width:15%",
            _type: "Boolean"
        },
        {
            key: "ClientName",
            label: "Client",
            sorter: true,
            filter: false,
            _filter: true,
            _style: "width:15%",
            _type: "String"
        },
        {
            key: "dbRelation",
            label: "Origin db",
            sorter: false,
            filter: false,
            _filter: false,
            _style: "width:15%",
            _type: "String"
        },
        {
            key: "spending",
            label: "Sale",
            sorter: true,
            filter: false,
            _filter: false,
            _type: "Integer"
        },
        {
            key: "sent",
            label: "Sent",
            sorter: true,
            filter: false,
            _filter: false,
            _type: "Integer"
        },
        {
            key: "total_delivery_pending",
            label: "Pendings",
            sorter: false,
            filter: false,
            _filter: false,
            _type: "Integer"
        },
        {
            key: "ok",
            label: "Ok",
            sorter: true,
            filter: false,
            _filter: false,
            _type: "Integer"
        },
        {
            key: "percent_ok",
            label: "Ok (%)",
            sorter: true,
            filter: false,
            _style: "width:5%",
            _filter: false,
            _type: "Number"
        },

        {
            key: "ko",
            label: "Ko",
            sorter: true,
            filter: false,
            _filter: false,
            _type: "Integer"
        },
        {
            key: "percent_ko",
            label: "Ko (%)",
            sorter: true,
            filter: false,
            _filter: false,
            _style: "width:5%",
            _type: "Number"
        },
        {
            key: "duplicate",
            label: "Duplicates",
            sorter: true,
            filter: false,
            _filter: false,
            _type: "Integer"
        },
        {
            key: "percent_duplicate",
            label: "Duplicates (%)", 
            sorter: true,
            filter: false,
            _filter: false,
            _style: "width:5%",
            _type: "Number"
        },
        {
            key: "error",
            label: "Error",
            sorter: true,
            filter: false,
            _filter: false,
            _type: "Integer"
        },
        {
            key: "percent_error",
            label: "Error (%)",
            sorter: true,
            filter: false,
            _filter: false,
            _style: "width:5%",
            _type: "Number"
        },
        // {
        //     key: "delivery_pending_methodEmail",
        //     label: "Delivery Pending Method Email",
        //     sorter: false,
        //     filter: false,
        //     _filter: false,
        //     _type: "Integer"
        // },
        // {
        //     key: "percent_methodEmail",
        //     label: "Method Email (%)",
        //     sorter: true,
        //     filter: false,
        //     _filter: false,
        //     _style: "width:5%",
        //     _type: "Number"
        // },
        // {
        //     key: "delivery_pending_duplicate_phone",
        //     label: "Delivery Pending Duplicate Phone",
        //     sorter: false,
        //     filter: false,
        //     _filter: false,
        //     _type: "Integer"
        // },
        // {
        //     key: "percent_duplicate_phone",
        //     label: "Duplicate Phone (%)",
        //     sorter: true,
        //     filter: false,
        //     _filter: false,
        //     _style: "width:5%",
        //     _type: "Number"
        // },
        // {
        //     key: "delivery_pending_duplicate_email",
        //     label: "Delivery Pending Duplicate Email",
        //     sorter: false,
        //     filter: false,
        //     _filter: false,
        //     _type: "Integer"
        // },
        // {
        //     key: "percent_duplicate_email",
        //     label: "Duplicate Email (%)",
        //     sorter: true,
        //     active: false,
        //     filter: false,
        //     _filter: false,
        //     _style: "width:5%",
        //     _type: "Number"
        // },
        {
            key: "created_at",
            label: "Created At",
            sorter: false,
            filter: false,
            _filter: false,
            _style: "width:10%",
            _type: "Date"
        },
    ],
    items: [],
    order: "desc",
    rows: 5,
    page: 1,
    total_pages: 1,
    loading: true,
    hover: true,
    pagination: true,
    sorter: {
        external: true,
        resetable: true,
    },
    sorterValue: {
        column: null,
        asc: true
    },
    size: "sm",
    columnFilter: true,
    allFields: [],
    itemsPerPageSelect: true,
    export: null,
    columnFilter: {
        external: true,
        lazy: true,
    },
    responsive: true,
    columnFilterValue: {
    },
    itemSelected: null,
    loadQueryFromUrl: true,
}